module.exports = __webpack_public_path__ + "img/20210816130305638zoo.52b9aba0.png";